/**
 * Builds packed-oil / other-sales table rows with product-wise subtotals,
 * mirroring the Blade daily transaction sheet grouping logic.
 */

function toNumber(value) {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
}

function createEmptyGroupTotals() {
  return {
    productName: '',
    quantitySum: 0,
    discountSum: 0,
    debitTotal: 0,
    creditTotal: 0,
  };
}

function pushProductSubtotal(bodyRows, totals) {
  if (!totals.productName) {
    return;
  }

  bodyRows.push({
    type: 'subtotal',
    productName: totals.productName,
    quantitySum: totals.quantitySum,
    discountSum: totals.discountSum,
    debitTotal: totals.debitTotal,
    creditTotal: totals.creditTotal,
  });
}

/**
 * @param {Array<object>|null|undefined} rows
 * @returns {{ bodyRows: Array<object> }}
 */
export function buildPackedOilSalesTableRows(rows) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return { bodyRows: [] };
  }

  const groups = new Map();

  rows.forEach((row, index) => {
    const productName = row.product_name || row.product_full_name || '';
    if (!groups.has(productName)) {
      groups.set(productName, []);
    }
    groups.get(productName).push({ row, index });
  });

  const bodyRows = [];

  groups.forEach((items, productName) => {
    const groupTotals = createEmptyGroupTotals();
    groupTotals.productName = productName;

    items.forEach(({ row, index }) => {
      groupTotals.quantitySum += toNumber(row.quantity);
      groupTotals.discountSum += toNumber(row.dis_amount);
      groupTotals.debitTotal += toNumber(row.dr_amount);
      groupTotals.creditTotal += toNumber(row.cr_amount);

      bodyRows.push({
        type: 'data',
        key: `${productName}-${row.name || ''}-${index}`,
        productName,
        customerName: row.name || row.customer_name || row.cust_name || '',
        quantity: row.quantity,
        sellingPrice: row.selling_price,
        discountAmount: row.dis_amount,
        debitAmount: row.dr_amount,
        creditAmount: row.cr_amount,
      });
    });

    pushProductSubtotal(bodyRows, groupTotals);
  });

  return { bodyRows };
}
